export default __webpack_public_path__ + "static/media/dec-action.86b4500c.mp4";